export default __webpack_public_path__ + "info-multiselect@2x.png";